import * as React from "react";
import { lazy } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import MainLayout from "./../layout/MainLayout";
const PendingClaims = lazy(() => import("../views/pending-claims"));

const MainRoutes = () => {
  const location = useLocation();
  return ( 
      <MainLayout showBreadcrumb={true}>
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<PendingClaims />} />
          <Route path="/dashboard/pending-claims" element={<PendingClaims />} />             
        </Routes>
      </MainLayout>
    
  );
};
export default MainRoutes;